import { render, staticRenderFns } from "./CallMe.vue?vue&type=template&id=40bb48c2&scoped=true"
import script from "./CallMe.vue?vue&type=script&lang=js"
export * from "./CallMe.vue?vue&type=script&lang=js"
import style0 from "./CallMe.vue?vue&type=style&index=0&id=40bb48c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb48c2",
  null
  
)

export default component.exports